import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import { FastField, FieldProps } from 'formik';
import React from 'react';
import { styled } from '@mui/material';

const StyledFormControl = styled(FormControl)`
  && {
    margin-top: 20px;
  }
`;

const StyledTextField = styled(TextField)`
  && {
    .MuiInputBase-root {
      background-color: white;
    }
  }
`;

export const DEFAULT_CHARACTER_LIMIT = 255;

export const CommentBox: React.FC = () => (
  <FastField
    name="comment"
    validate={(value?: string) =>
      (value?.length || 0) > DEFAULT_CHARACTER_LIMIT
    }
  >
    {({ field, meta: { error } }: FieldProps<string | undefined>) => (
      <StyledFormControl fullWidth>
        <StyledTextField
          id="comment-text-field"
          label="Comment (optional)"
          multiline
          rows={4}
          variant="outlined"
          {...field}
          error={!!error}
          helperText={`${field.value?.length || 0}/${DEFAULT_CHARACTER_LIMIT}`}
        />
      </StyledFormControl>
    )}
  </FastField>
);
